import React from "react";
import { DynamicTable } from "@maherunlocker/custom-react-table";
import { CardBody } from "reactstrap";
import { PlusIcon } from "@aureskonnect/react-ui";

import PrinterConfig from "@pages/Peripherals/Printers/PrinterConfig";
import { ConfirmationInitializationMessage } from "@components/Common/ConfirmationInitializationMessage";
import { ConfirmationDeleteMessage } from "@components/Common/ConfirmationDeleteMessage";
import { AlertDeletePeripheralMessage } from "@components/Common/AlertDeletePeripheralMessage";
import PrepheralCardFooter from "./PrepheralCardFooter";
import { CustomMainColorIconButton } from "@components/Common/CustomMainColorIconButton";
import { ConfirmationMessageEditPeripheral } from "@components/Common/ConfirmationMessageEditPeripheral";
import { CustomMainColorButtonWithIcon } from "@components/Common/CustomMainColorButtonWithIcon";

import { usePrinter } from "./usePrinter";

import "../index.css";

type DeviceAssociateModalType = {
    setIsDeviceAssociateModalOpened: Function;
    oneShop: boolean;
    isDeviceAssociateModalOpened: boolean;
    rowData: any;
    dataIsUpdated: boolean | number;
    setDataIsUpdated: Function;
    selectedRows: any;
};

export default function Printer({
    setIsDeviceAssociateModalOpened,
    isDeviceAssociateModalOpened,
    rowData,
    dataIsUpdated,
    setDataIsUpdated,
    selectedRows,
}: DeviceAssociateModalType) {
    const {
        t,
        getAuthHeader,
        i18nextLng,
        oneShop,
        userID,
        franchiseID,
        shopID,
        isAddPeripheralClicked,
        setIsAddPeripheralClicked,
        modify,
        editedData,
        setEditedData,
        setData,
        dataIsPrinterUpdated,
        setDataPrinterIsUpdated,
        filterActive,
        setLocalFilterActive,
        isConfirmationEditRunning,
        setIsConfirmationEditRunning,
        isAddNewPrinterButtonClicked,
        printerId,
        setIsUpdateOperation,
        isModalOpened,
        setIsModalOpened,
        isModalDeleteAssociatePeripheralOpened,
        setIsModalDeleteAssociatePeripheralOpened,
        isInInitializationModalOpened,
        setIsInInitializationModalOpened,
        isEdited,
        setIsEdited,
        inputDesignation,
        setInputDesignation,
        inputIp,
        setInputIp,
        arrayOfCustomColumns,
        customJsxComponent,
        data,
    } = usePrinter({ rowData, selectedRows });

    const validSelectedRows = React.useMemo(
        () => selectedRows.filter(
            (elt: any) => elt[t("Application")] !== ""
        ),
        [selectedRows, t]
    );
    const resolvedShopId = oneShop
        ? shopID
        : validSelectedRows.length > 0
        ? validSelectedRows[0].shopId
        : rowData.shopId;

    return (
        <React.Fragment>
            <CardBody
                className="p-1"
                style={{
                    maxHeight: isAddPeripheralClicked ? "initial" : "720px",
                }}
            >
                <div
                    style={{
                        display: "grid",
                        minHeight: "650px",
                        gridTemplateColumns: isAddPeripheralClicked
                            ? "2fr 1fr "
                            : "auto",
                        gridColumnGap: "4px",
                        marginBottom: isAddPeripheralClicked ? "70px" : "0px",
                        border: 0,
                    }}
                >
                    <DynamicTable
                        requestHeader={{
                            "Accept-Language": i18nextLng,
                            ...getAuthHeader,
                        }}
                        setData={setData}
                        url={`${process.env.REACT_APP_API_V2_URL}/settings/printers?userId=${userID}&shopId=${resolvedShopId}&franchiseId=${franchiseID}`}
                        customJsxSideFilterButton={
                            !isAddPeripheralClicked &&
                            modify ? (
                                <div className="d-flex justify-content-start align-items-center">
                                    <span
                                        onClick={() => {
                                            setEditedData([]);
                                            setIsAddPeripheralClicked(
                                                !isAddPeripheralClicked
                                            );
                                        }}
                                        className="afa_btn_addPeripheral"
                                    >
                                        <CustomMainColorButtonWithIcon
                                            icon="PlusIcon"
                                            iconPosition="left"
                                            className="w-100"
                                            style={{ height: "0px" }}
                                            rounded
                                            variant="primary"
                                        >
                                            {t("Add device")}
                                        </CustomMainColorButtonWithIcon>
                                    </span>
                                </div>
                            ) : modify ? (
                                <div className="d-flex justify-content-start">
                                    <CustomMainColorIconButton
                                        icon="PlusIcon"
                                        rounded
                                        disabled={editedData.length !== 0}
                                        onClick={() => {
                                            if (isEdited)
                                                setIsInInitializationModalOpened(
                                                    true
                                                );
                                            else {
                                                setInputDesignation(false);
                                                setInputIp(false);
                                            }
                                        }}
                                    >
                                        <PlusIcon
                                            height={20}
                                            width={20}
                                            fill="white"
                                        />
                                    </CustomMainColorIconButton>
                                </div>
                            ) : null
                        }
                        actionColumn={customJsxComponent}
                        setDataIsUpdated={setDataPrinterIsUpdated}
                        dataIsUpdated={dataIsPrinterUpdated}
                        showGlobalFilter
                        filterActive={filterActive}
                        setLocalFilterActive={setLocalFilterActive}
                        arrayOfCustomColumns={arrayOfCustomColumns}
                        minHeight="520px"
                        maxHeight="520px"
                    />
                    {isAddPeripheralClicked ? (
                        <PrinterConfig
                            setIsAddPrinterClicked={setIsAddPeripheralClicked!}
                            isAddPrinterClicked={isAddPeripheralClicked}
                            setDataIsUpdated={setDataPrinterIsUpdated}
                            editedData={editedData}
                            setEditedData={setEditedData}
                            isAddNewPrinterButtonClicked={
                                isAddNewPrinterButtonClicked
                            }
                            shopIdPrinter={
                                validSelectedRows.length > 0
                                    ? validSelectedRows[0].shopId
                                    : rowData.shopId
                            }
                            localShopId={[
                                validSelectedRows.length > 0
                                    ? validSelectedRows[0].shopId
                                    : rowData.shopId,
                            ]}
                            inputDesignation={inputDesignation}
                            setInputDesignation={setInputDesignation}
                            inputIp={inputIp}
                            setInputIp={setInputIp}
                            dataTable={data}
                            setIsUpdateOperation={setIsUpdateOperation}
                            isConsult={false}
                            setIsConsult={() => {}}
                            isComingFromAssociate={true}
                        />
                    ) : null}
                </div>
            </CardBody>
            {!isAddPeripheralClicked ? (
                <PrepheralCardFooter
                    dataIsUpdated={dataIsUpdated}
                    setIsEdited={setIsEdited}
                    setIsDeviceAssociateModalOpened={
                        setIsDeviceAssociateModalOpened
                    }
                    isDeviceAssociateModalOpened={isDeviceAssociateModalOpened}
                    rowData={rowData}
                    setDataIsUpdated={setDataIsUpdated}
                    selectedRows={selectedRows}
                    isPrinter={true}
                />
            ) : null}
            {!isModalDeleteAssociatePeripheralOpened ? (
                <ConfirmationDeleteMessage
                    isModalOpened={isModalOpened}
                    setIsModalOpened={setIsModalOpened}
                    setDataIsUpdated={setDataPrinterIsUpdated}
                    text={t("Please confirm archivation of this device")}
                    message={t("The device was successfully archived")}
                    apiUrl={`${
                        process.env.REACT_APP_API_V2_URL
                    }/settings/printer?userId=${userID}&shopId=${
                        oneShop ? shopID : rowData.shopId
                    }&franchiseId=${franchiseID}&id=${printerId}&isArchived=true`}
                    setGlobalDataIsUpdated={setDataIsUpdated}
                    data={{ shopId: oneShop ? shopID : rowData.shopId }}
                />
            ) : (
                <AlertDeletePeripheralMessage
                    text={t(
                        "This device is associated with one or more applications! Unable to perform delete action"
                    )}
                    isModalDeleteAssociatePeripheralOpened={
                        isModalDeleteAssociatePeripheralOpened
                    }
                    setIsModalDeleteAssociatePeripheralOpened={
                        setIsModalDeleteAssociatePeripheralOpened
                    }
                />
            )}

            {isInInitializationModalOpened ? (
                <ConfirmationInitializationMessage
                    isModalOpened={isInInitializationModalOpened}
                    setIsModalOpened={setIsInInitializationModalOpened}
                    setIsClicked={setIsAddPeripheralClicked}
                    isClicked={isAddPeripheralClicked}
                    setIsEdited={setIsEdited}
                />
            ) : null}
            {isConfirmationEditRunning ? (
                <ConfirmationMessageEditPeripheral
                    isModalOpened={isConfirmationEditRunning}
                    setIsModalOpened={setIsConfirmationEditRunning}
                    setCancel={setIsAddPeripheralClicked}
                    archive={false}
                />
            ) : null}
        </React.Fragment>
    );
}
